import moment from 'moment';

const useSortedMissedCalls = (calls = []) => {
  const groupedMap = new Map();

  calls.forEach((call) => {
    const callerId = call.callerId;

    if (groupedMap.has(callerId)) {
      const existing = groupedMap.get(callerId);
      existing.countNotAnswer += 1;
    } else {
      groupedMap.set(callerId, { ...call, countNotAnswer: 1 });
    }
  });

  return Array.from(groupedMap.values()).sort((a, b) => {
    if (a.ivrDtmf !== b.ivrDtmf) {
      return a.ivrDtmf ? -1 : 1;
    }

    return moment(b.createdAt).valueOf() - moment(a.createdAt).valueOf();
  });
};

export default useSortedMissedCalls;
